// extracted by mini-css-extract-plugin
export default {"badges":"SjJ4X","wrapper":"ywUOp","badge":"kIWnF","text":"DGzro","icon":"rUy1V"};